import { useTranslation } from "react-i18next";

/**
 * Convenience hook for admin panel translations.
 * All keys are automatically prefixed with "admin."
 *
 * Usage:
 *   const { t, isRtl } = useAdminT();
 *   t("common.save")     → "Save" | "حفظ"
 *   t("nav.dashboard")   → "Dashboard" | "لوحة التحكم"
 */
export function useAdminT() {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === "ar";

    return {
        /** Translate an admin UI key (auto-prefixed with "admin.") */
        t: (key: string, opts?: Record<string, unknown>) =>
            t(`admin.${key}`, opts),
        /** Raw i18n instance for language switching */
        i18n,
        /** True when the active language is Arabic */
        isRtl,
        /** Current language code ("en" | "ar") */
        lang: i18n.language as "en" | "ar",
        /** Switch admin panel language */
        switchLanguage: (lang: "en" | "ar") => {
            i18n.changeLanguage(lang);
            document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
            document.documentElement.lang = lang;
        },
    };
}
